// ATTP NEXUS — Per-module colour identity (hex codes from FSD Supplement 2, Part N)
export const MODULE_THEMES = {
  // ATTP NEXUS main brand
  main: {
    primary: '#1F3864', secondary: '#2E75B6', accent: '#4DA6FF',
    bg: '#F5F7FA', textOnPrimary: '#F5F7FA',
  },
  financials: {
    primary: '#0A3D2E', secondary: '#1A6B4A', accent: '#27AE60',
    bg: '#F0FFF4', textOnPrimary: '#F0FFF4',
  },
  estate: {
    primary: '#2C3E50', secondary: '#4A6741', accent: '#E67E22',
    bg: '#FFF8F0', textOnPrimary: '#FFF8F0',
  },
  offices: {
    primary: '#1B2A4A', secondary: '#2E4A7A', accent: '#00BCD4',
    bg: '#F0F4F8', textOnPrimary: '#F0F4F8',
  },
  education: {
    primary: '#7B3F00', secondary: '#A0522D', accent: '#F39C12',
    bg: '#FFFBF0', textOnPrimary: '#FFFBF0',
  },
  events: {
    primary: '#4A148C', secondary: '#6A1B9A', accent: '#E91E63',
    bg: '#F5F0FF', textOnPrimary: '#F5F0FF',
  },
  lms: {
    primary: '#003366', secondary: '#0055A5', accent: '#FF6F00',
    bg: '#F0F4F8', textOnPrimary: '#F0F4F8',
  },
  engineering: {
    primary: '#1A1A2E', secondary: '#16213E', accent: '#E63946',
    bg: '#F5F5F5', textOnPrimary: '#F5F5F5',
  },
  corporate: {
    primary: '#1C1C1C', secondary: '#2D2D2D', accent: '#C9A84C',
    bg: '#FAFAFA', textOnPrimary: '#FAFAFA',
  },
  // Healthcare — derived (not in supplement); calm medical blue with teal accent
  healthcare: {
    primary: '#0B3954', secondary: '#1E5F8C', accent: '#0EA5E9',
    bg: '#F0F8FF', textOnPrimary: '#F0F8FF',
  },
  // HR — premium executive purple (workday/oracle HCM-inspired)
  hr: {
    primary: '#1E1B4B', secondary: '#312E81', accent: '#A78BFA',
    bg: '#F5F3FF', textOnPrimary: '#F5F3FF',
  },
};

export const themeFor = (slug) => MODULE_THEMES[slug] || MODULE_THEMES.main;
